export default __webpack_public_path__ + "img/bg-main.544698c2.svg";